import Button from '@repo/ui/components/button';
import ExternalSvgIcon from '@repo/ui/components/external-svg-icon';
import { JSX, useState } from 'react';
import { Image } from '../../types/image';
import DialogSimple from '../dialog-simple/dialog-simple';

interface IconWithTitle {
    title?: string;
    description?: string;
    button?: Button;
    showButton?: boolean;
    showDialog?: boolean;
    dialog?: DialogSimple;
    image?: Image;
}

function IconWithTitle(props: IconWithTitle): JSX.Element {
    const { button, dialog } = props;
    const [container, setContainer] = useState<HTMLElement | null>(null);
    const [dialogOpened, setDialogOpened] = useState(false);
    const displayButton = button && props.showButton && button.label;
    const displayDialog = props.showDialog && dialog;
    const isSvgIcon = props.image?.src?.endsWith('.svg') || false;
    const iconAlt = props?.image?.alt || props.title || props.description;

    const icon = isSvgIcon ? (
        <ExternalSvgIcon src={props.image?.src!} size={48} title={iconAlt} />
    ) : (
        <img src={props.image?.src} alt={iconAlt} width={48} height={48} className="object-contain" />
    );

    const content = (
        <>
            {props.image?.src && icon}
            {props.title && (
                <h3 className="text-text-titles-primary group-hover:text-text-hover-primary font-bold">
                    {props.title}
                </h3>
            )}
            {props.description && (
                <p className="font-style-body-small text-text-titles-primary group-hover:text-text-hover-primary">
                    {props.description}
                </p>
            )}
        </>
    );

    return (
        <article className="flex flex-col items-center justify-center" ref={setContainer} data-testid="icon-with-title">
            {displayDialog ? (
                <>
                    <DialogSimple
                        {...dialog}
                        container={container}
                        open={dialogOpened}
                        onClose={() => setDialogOpened(false)}
                    />

                    <button
                        onClick={() => setDialogOpened(true)}
                        className="group flex cursor-pointer flex-col items-center justify-center gap-1.5"
                    >
                        {content}
                    </button>
                </>
            ) : (
                content
            )}

            {displayButton && <Button {...button} className="mt-2.5" />}
        </article>
    );
}

export default IconWithTitle;
